import type { AppDefinition } from '../../types/apps';

export const RapidsAppDefinition: AppDefinition = {
  appId: 'rapids',
  name: 'Rapids',
  version: '1.0.0',
  description: 'Jump the obstacles and ride the current without missing a beat.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'rapids',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'GameController',
    phosphorWeight: 'duotone',
    color: '#3b82f6',
    metadata: {
      source: 'app',
      appId: 'rapids',
      isAppIcon: true,
    },
  },

  category: 'games',
  isCore: false,
  isSystem: true,
};

export default RapidsAppDefinition;
